import ControlViewModel from '@/ViewModels/ControlViewModel';
import { Handler } from '#/DefaultViewExtensionInterfaces';
import ImageViewModelT from '@/ViewModels/Controls/ImageViewModel';
import LinkViewModelT from '@/ViewModels/Controls/LinkViewModel';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import DropDownListViewModelT from '@/ViewModels/Controls/DropDownListViewModel';
import ComponentManager from '@/Management/ComponentManager';
export default class MultiLinkViewModel extends ControlViewModel {
    /**
    * Ein Handler, der aufgerufen wird, wenn der Link angeklickt wird
    */
    public onClick: Handler;
    public activeIndex: any;
    public selectedChild: any;
    public mode: any;
    /**
    * Definiert eine Untergruppe an Links
    * @type {[LinkViewModel]}
    */
    public items: any;
    /**
    * Gibt an, ob es sich um einen Link in der ToolBar handelt
    */
    public isToolBarLink: any;
    public toggleBtnLinkVM: any;
    public currentModeToolTipContent: any;
    /**
    * Das ViewModel für die DropDownList für Kindelemente
    * @type {DropDownListViewModel}
    */
    public dropDownList: any;
    private ImageViewModel: any;
    private LinkViewModel: any;
    private LabelViewModel: any;
    private DropDownListViewModel: any;
    constructor(params: any) {
        super(params);
        this.ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelT>('ImageViewModel');
        this.LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModelT>('LinkViewModel');
        this.LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
        this.DropDownListViewModel = ComponentManager.getViewModel<typeof DropDownListViewModelT>('DropDownListViewModel');
        this.onClick = this.handlerOrDefault(params.onClick);
        this.activeIndex = this.paramOrDefault(params.activeIndex, 0);
        this.selectedChild = this.paramOrDefault(params.selectedChild, 0);
        this.defineSubscription(this.selectedChild, () => {
            // wenn die Auswahl aus der Selectbox geändert wurde, muss der Button angepasst werden
            let newBtn = this.getItemWithValue(this.selectedChild());
            this.setNewBtnValues(newBtn);
        });
        this.mode = this.observableOrDefault(params.mode, null);
        this.items = this.observableOrDefault(params.items, []);
        this.isToolBarLink = this.observableOrDefault(params.isToolBarLink, false);
        this.toggleBtnLinkVM = this.paramOrDefault(params.toggleBtnLinkVM,
            new this.LinkViewModel({
                parentLocator: this.locator,
                locator: 'toggleBtn',
                isToolBarLink: this.isToolBarLink,
                childValue: '',
                isEnabled: this.isEnabled,
                image: new this.ImageViewModel({
                    source: '',
                    parentLocator: this.locator,
                    locator: 'toggleBtn.image',
                    // TODO: Alternativtext
                }),
                onClick: () => {
                    this.setNextMode();
                }
            })
        );
        this.currentModeToolTipContent = this.paramOrDefault(params.currentModeToolTipContent, null);
        this.dropDownList = (() => {
            return new this.DropDownListViewModel({
                parentLocator: this.locator,
                locator: 'dropdown',
                data: this.defineComputed(() => {
                    let childLinks = this.items();
                    let result = [];
                    for (let i = 0; i < childLinks.length; i++) {
                        let isSvg = childLinks[i].image.svgSource() != null;
                        result.push({
                            childValue: childLinks[i].childValue,
                            caption: childLinks[i].label.caption(),
                            image: isSvg ? childLinks[i].image.svgSource() : childLinks[i].image.convertedSource(),
                            locator: childLinks[i].locator,
                            isSvg: isSvg
                        });
                    }
                    return result;
                }),
                value: this.selectedChild,
                dataTextField: 'caption',
                isEnabled: this.isEnabled,
                dataValueField: 'childValue',
                template: '# if (data && data.image && data.caption && data.isSvg) {# <div class="svg-wrapper">#= data.image #</div><span>#:data.caption#</span>#} else if (data && data.image && data.caption) { #<img src=\"#:data.image#\" /><span>#:data.caption#</span># } #',
                valueTemplate: ' ',
                isToolBarLink: this.isToolBarLink,
                isAutoWidth: this.isToolBarLink,
                technicalName: this.technicalName
            });
        })();
        (() => {
            let value = this.selectedChild();
            let btn = this.getItemWithValue(value);
            this.setNewBtnValues(btn);
        })();
        ControlViewModel.checkProperties(this, params);
    }
    public setNextMode(): any {
        let newBtn = this.getNextItem();
        this.setNewBtnValues(newBtn, true);
        if (newBtn) {
            this.selectedChild(newBtn.childValue());
        }
    }
    private setNewBtnValues(newBtn: any, doClick?: any): any {
        if (newBtn && newBtn.childValue() != this.toggleBtnLinkVM.childValue()) {
            this.toggleBtnLinkVM.childValue(newBtn.childValue());
            this.toggleBtnLinkVM.image.source(newBtn.image.source());
            if (doClick === true) {
                newBtn.onClick();
            }
        }
    }
    private getItemWithValue(value: any): any {
        let items = this.items();
        for (const item of items) {
            if (item.childValue() === value) {
                return item;
            }
        }
        return null;
    }
    private getNextItem(): any {
        let value = this.selectedChild();
        let items = this.items();
        for (let i = 0; i < items.length; i++) {
            let item = items[i];
            if (item.childValue() === value) {
                let nextIndex = +i + 1;
                if (items[nextIndex]) {
                    return items[nextIndex];
                }
                else {
                    return items[0];
                }
            }
        }
        return null;
    }
}

ComponentManager.setViewModel('MultiLinkViewModel', MultiLinkViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');